import { Goal } from "./types";

const normalizeCategory = (value: string): string => value.trim().toLowerCase();

const getGoalCategories = (goal: Goal): string[] => {
  if (Array.isArray(goal.categories)) return goal.categories;
  // Backward compatibility for older payloads that might still send `category`.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const legacy = (goal as any)?.category;
  if (typeof legacy === "string" && legacy.trim()) return [legacy];
  return [];
};

export const filterGoalsByCategories = (
  goals: Goal[],
  selectedCategories: string[]
): Goal[] => {
  const normalized = selectedCategories
    .map((c) => (typeof c === "string" ? normalizeCategory(c) : ""))
    .filter(Boolean);
  if (normalized.length === 0) return goals;

  const set = new Set(normalized);
  return goals.filter((g) => {
    const cats = getGoalCategories(g)
      .map((c) => (typeof c === "string" ? normalizeCategory(c) : ""))
      .filter(Boolean);
    if (cats.length === 0) return false;
    return cats.some((c) => set.has(c));
  });
};

export const getGoalCategoryOptions = (goals: Goal[]): string[] => {
  const map = new Map<string, string>();
  goals.forEach((g) => {
    getGoalCategories(g).forEach((raw) => {
      if (typeof raw !== "string") return;
      const trimmed = raw.trim();
      if (!trimmed) return;
      const key = trimmed.toLowerCase();
      if (!map.has(key)) map.set(key, trimmed);
    });
  });
  return Array.from(map.values()).sort((a, b) => a.localeCompare(b));
};
